import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    min-height: 100%;
  }

  body {
    background: #fff;
    -webkit-font-smoothing: antialiased !important;
  }

  body, input, button {
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;
  }

  input {
    color: #6d6d6d;
    height: 35px;
    padding: 7px 7px;
  }

  span {
    color: #606675;
  }

  button {
    cursor: pointer;
  }

`;
